(function () {
  "use strict";

  var isMobile = window.matchMedia("(max-width: 768px)").matches;

  function arrowSvg(dir, active) {
    var op = active ? "" : ' stroke-opacity="0.4"';
    if (dir === "prev") {
      return (
        '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="19.5" transform="matrix(-1 0 0 1 40 0)" stroke="#3A3A42"' +
        op +
        '/><path d="M19 13L12 19.6667M12 19.6667L19 26.3333M12 19.6667H28" stroke="#3A3A42"' +
        op +
        ' stroke-width="2" stroke-linecap="round"/></svg>'
      );
    }
    return (
      '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="19.5" stroke="#3A3A42"' +
      op +
      '/><path d="M21 13L28 19.6667M28 19.6667L21 26.3333M28 19.6667H12" stroke="#3A3A42"' +
      op +
      ' stroke-width="2" stroke-linecap="round"/></svg>'
    );
  }

  function buildStars(count) {
    var html = "";
    for (var i = 0; i < count; i++) {
      html +=
        '<svg class="result-star result-star--filled" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    }
    return html;
  }

  document.addEventListener("DOMContentLoaded", function () {
    var root = document.getElementById("yb-003-survey-questions");
    if (!root) return;
    var apiUrl = (window.__MC__CONFIG__ && window.__MC__CONFIG__.apiUrl) || "";
    var apiHeaders =
      (window.__MC__CONFIG__ && window.__MC__CONFIG__.headers) || {};
    var configEl = root.querySelector("[data-survey-config]");
    if (!configEl) return;
    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error("[yb-003] config parse error", e);
      return;
    }

    var activityCode = config.activityCode;
    var q0Config = config.q0;
    var quizA = config.quizA;
    var quizB = config.quizB;
    var shareConfig = config.shareConfig;
    var uiText = config.uiText || {};
    var facebookAppId = (shareConfig && shareConfig.facebookAppId) || "";
    var progressAvatarPcUrl = config.progressAvatarPcUrl || "";
    var progressAvatarPcUrl2x = config.progressAvatarPcUrl2x || "";
    var progressAvatarMobileUrl = config.progressAvatarMobileUrl || "";
    var progressAvatarMobileUrl2x = config.progressAvatarMobileUrl2x || "";
    var validationText = config.validationText || "Please enter your email";
    var validationEmail =
      config.validationEmail || "Please enter a valid email address";
    var shareXText = uiText.shareXText || "";

    var quizSection = root.querySelector(".quiz-section");
    var emailSection = root.querySelector(".email-main");
    var resultSection = root.querySelector(".result-section");
    var resultDialogOverlay = root.querySelector(".result-dialog-overlay");
    var shareOverlay = root.querySelector(".share-modal-overlay");
    var questionBox = root.querySelector(".question-box");
    var progressInner = root.querySelector(
      ".question-progress-bar-container-inner",
    );
    var progressAvatar = root.querySelector(
      ".question-progress-bar-container .progress-avatar",
    );
    var pcSubmitBtn = root.querySelector(".question-btn-wrapper");
    var mobileSubmitBtn = root.querySelector(".submit-btn");
    var mobilePrevBtn = root.querySelector(".mobile-btn-item.prev");
    var mobileNextBtn = root.querySelector(".mobile-btn-item.next");
    var emailInput = root.querySelector('.email-main input[type="email"]');
    var emailCheckbox = root.querySelector(
      '.email-main input[type="checkbox"]',
    );
    var emailSubmitBtn = root.querySelector(".email-submit-btn");
    var ignoreLink = root.querySelector(".ignore-email-link");
    var errorTip = root.querySelector(".email-main .error-tip");
    var resultCardEl = root.querySelector(".result-card");
    var dialogClose = root.querySelector(".result-dialog-close");
    var dialogHeadlineEl = root.querySelector(".result-dialog-headline");
    var dialogTitleEl = root.querySelector(".result-dialog-content-title");
    var dialogDescEl = root.querySelector(".result-dialog-content-desc");
    var dialogStarsEl = root.querySelector(".result-dialog-stars");
    var dialogQrcodeImg = root.querySelector(".result-dialog-qrcode-img");
    var dialogImg = root.querySelector(".result-dialog-img");
    var btnShare = root.querySelector(".result-action-btns .btn-share");
    var btnRetake = root.querySelector(".result-action-btns .btn-retake");
    var shareModalClose = root.querySelector(".share-modal-close");
    var shareCardTitle = root.querySelector(".share-card-title");
    var shareCardSubtitle = root.querySelector(".share-card-subtitle");
    var shareQrcodeImg = root.querySelector(".share-qrcode-img");
    var shareCardImg = root.querySelector(".share-card-img");
    var btnSaveImage = root.querySelector('[data-share-action="save-image"]');
    var btnCopyLink = root.querySelector('[data-share-action="copy-link"]');
    var btnShareX = root.querySelector('[data-share-action="share-x"]');

    /* ── 状态变量 ── */
    var fullQuestionList = [];
    var currentIndex = 0;
    var answerMap = {};
    var q0SelectedRole = null;
    var submitCode = null;
    var currentResultConfig = null;
    var isMounted = false;
    var quizCompleted = false;
    var progressLocked = false;
    /* maxCompletedSteps：已到达/完成的最高步数（1~total），只增不减
       步数映射：
         Q0到达 = 1，Q0答完切Q1 = 2，...，最后一题答完 = total = fullQuestionList.length */
    var maxCompletedSteps = 0;
    var autoAdvanceTimer = null;

    if (progressAvatar) {
      var baseUrl = isMobile ? progressAvatarMobileUrl : progressAvatarPcUrl;
      var baseUrl2x = isMobile
        ? progressAvatarMobileUrl2x
        : progressAvatarPcUrl2x;
      if (baseUrl) progressAvatar.src = baseUrl;
      if (baseUrl && baseUrl2x) {
        progressAvatar.srcset = baseUrl + " 1x, " + baseUrl2x + " 2x";
        progressAvatar.sizes = isMobile ? "80px" : "130px";
      }
    }
    if (shareOverlay) {
      shareOverlay.classList.remove("show");
    }

    function buildQ0Question() {
      return {
        code: "Q0",
        title: q0Config.title || "Choose Your Role",
        isQ0: true,
        answerList: [
          { code: "A", text: q0Config.optionA || "I am a mom" },
          { code: "B", text: q0Config.optionB || "I am a partner" },
        ],
      };
    }

    /* ── 启动 ── */
    function startQuiz() {
      fullQuestionList = [buildQ0Question()];
      currentIndex = 0;
      answerMap = {};
      q0SelectedRole = null;
      isMounted = false;
      quizCompleted = false;
      progressLocked = false;
      maxCompletedSteps = 0;
      quizSection.classList.add("show");
      updateProgress();
      renderQuestion();
    }

    /* ── 渲染题目 ── */
    function renderQuestion() {
      var q = fullQuestionList[currentIndex];
      if (!q) return;
      if (!isMounted) {
        questionBox.innerHTML = "";
        var titleDom = document.createElement("div");
        titleDom.className = "question-title";
        questionBox.appendChild(titleDom);
        var contentDom = document.createElement("div");
        contentDom.className = "question-content";
        var wrapper = document.createElement("div");
        wrapper.className = "question-answer-wrapper";
        contentDom.appendChild(wrapper);
        questionBox.appendChild(contentDom);
        var prevBtn = document.createElement("div");
        prevBtn.className = "question-prev";
        prevBtn.setAttribute("role", "button");
        prevBtn.setAttribute("tabindex", "0");
        var nextBtn = document.createElement("div");
        nextBtn.className = "question-next";
        nextBtn.setAttribute("role", "button");
        nextBtn.setAttribute("tabindex", "0");
        questionBox.appendChild(prevBtn);
        questionBox.appendChild(nextBtn);
        prevBtn.addEventListener("click", function () {
          if (prevBtn.getAttribute("aria-disabled") === "true") return;
          goPrev();
        });
        prevBtn.addEventListener("keydown", function (e) {
          if (
            e.key === "Enter" ||
            e.key === " " ||
            e.keyCode === 13 ||
            e.keyCode === 32
          ) {
            e.preventDefault();
            if (prevBtn.getAttribute("aria-disabled") === "true") return;
            goPrev();
          }
        });
        nextBtn.addEventListener("click", function () {
          if (nextBtn.getAttribute("aria-disabled") === "true") return;
          goNext(false);
        });
        nextBtn.addEventListener("keydown", function (e) {
          if (
            e.key === "Enter" ||
            e.key === " " ||
            e.keyCode === 13 ||
            e.keyCode === 32
          ) {
            e.preventDefault();
            if (nextBtn.getAttribute("aria-disabled") === "true") return;
            goNext(false);
          }
        });
        contentDom.addEventListener("click", function (e) {
          var t = e.target.closest(".question-answer-item");
          if (t) {
            selectAnswer(t);
          }
        });
        if (mobilePrevBtn) {
          mobilePrevBtn.setAttribute("aria-hidden", "true");
          mobilePrevBtn.addEventListener("click", function () {
            goPrev();
          });
        }
        if (mobileNextBtn) {
          mobileNextBtn.setAttribute("aria-hidden", "true");
          mobileNextBtn.addEventListener("click", function () {
            goNext(false);
          });
        }
        if (pcSubmitBtn) {
          pcSubmitBtn.classList.remove("show");
          pcSubmitBtn.addEventListener("click", submitQuiz);
        }
        if (mobileSubmitBtn) {
          mobileSubmitBtn.classList.remove("show");
          mobileSubmitBtn.addEventListener("click", submitQuiz);
        }
        isMounted = true;
      }
      questionBox.querySelector(".question-title").innerHTML = q.title;
      var wrapper = questionBox.querySelector(".question-answer-wrapper");
      var html = "";
      q.answerList.forEach(function (opt) {
        var active = answerMap[q.code] === opt.code ? " active" : "";
        html +=
          '<div class="question-answer-item' +
          active +
          '" data-code="' +
          opt.code +
          '">' +
          opt.text +
          "</div>";
      });
      wrapper.innerHTML = html;
      updateNavArrows();
      updateMobileNav();
      updateSubmitBtn();
    }

    /* ── 选答案 ── */
    function selectAnswer(target) {
      var q = fullQuestionList[currentIndex];

      /* Q0 点击同一答案：只高亮，切下一题，不重置状态 */
      if (
        q.isQ0 &&
        target.dataset.code === q0SelectedRole &&
        q0SelectedRole !== null
      ) {
        questionBox
          .querySelectorAll(".question-answer-item")
          .forEach(function (el) {
            el.classList.remove("active");
          });
        target.classList.add("active");
        clearTimeout(autoAdvanceTimer);
        autoAdvanceTimer = setTimeout(function () {
          autoAdvanceTimer = null;
          goNext(true);
        }, 400);
        return;
      }

      questionBox
        .querySelectorAll(".question-answer-item")
        .forEach(function (el) {
          el.classList.remove("active");
        });
      target.classList.add("active");
      answerMap[q.code] = target.dataset.code;

      /* Q0 换答案：重置所有状态重新开始 */
      if (q.isQ0) {
        q0SelectedRole = target.dataset.code;
        var questions =
          q0SelectedRole === "A" ? quizA.questions : quizB.questions;
        fullQuestionList = [buildQ0Question()].concat(questions);
        answerMap = {};
        answerMap[q.code] = q0SelectedRole;
        quizCompleted = false;
        progressLocked = false;
        maxCompletedSteps = 0;
        updateSubmitBtn();
        updateProgress();
        clearTimeout(autoAdvanceTimer);
        autoAdvanceTimer = setTimeout(function () {
          autoAdvanceTimer = null;
          goNext(true);
        }, 400);
        return;
      }

      /* 非 Q0 题：
         - quizCompleted=true（已完成所有题目）：只更新当前题答案，不清空后续，不重置状态，不自动切题
         - quizCompleted=false（答题进行中）：清空后续答案，非最后题自动切下一题
      */
      if (quizCompleted) {
        /* 已完成状态：仅更新答案，保持 Submit 和进度 */
        updateSubmitBtn();
        return;
      }

      /* 答题进行中：清空后续题目答案 */
      for (var ci = currentIndex + 1; ci < fullQuestionList.length; ci++) {
        var fq = fullQuestionList[ci];
        if (fq) {
          answerMap[fq.code] = null;
        }
      }

      if (currentIndex === fullQuestionList.length - 1) {
        /* 最后一题答完：锁定进度和 Submit */
        quizCompleted = true;
        progressLocked = true;
        maxCompletedSteps = fullQuestionList.length;
        updateProgress();
        updateSubmitBtn();
      } else {
        /* 非最后题：400ms 后自动切下一题 */
        clearTimeout(autoAdvanceTimer);
        autoAdvanceTimer = setTimeout(function () {
          autoAdvanceTimer = null;
          goNext(true);
        }, 400);
      }
    }

    /* ── 下一题 ── */
    function goNext(skipValidation) {
      if (currentIndex >= fullQuestionList.length - 1) return;
      var q = fullQuestionList[currentIndex];
      if (!skipValidation && !answerMap[q.code]) {
        var content = questionBox.querySelector(".question-content");
        if (content && !content.classList.contains("animate__animated")) {
          content.classList.add("animate__animated", "animate__headShake");
          setTimeout(function () {
            content.classList.remove("animate__animated", "animate__headShake");
          }, 1000);
        }
        return;
      }
      currentIndex += 1;
      if (currentIndex > maxCompletedSteps) {
        maxCompletedSteps = currentIndex;
      }
      updateProgress();
      renderQuestion();
      updateSubmitBtn();
    }

    /* ── 上一题 ── */
    function goPrev() {
      if (currentIndex <= 0) return;
      currentIndex -= 1;
      updateProgress();
      renderQuestion();
      updateSubmitBtn();
    }

    /* ── 导航箭头 ── */
    function updateNavArrows() {
      var pb = questionBox.querySelector(".question-prev");
      var nb = questionBox.querySelector(".question-next");
      var prevDisabled = currentIndex <= 0;
      var nextDisabled = currentIndex >= fullQuestionList.length - 1;
      if (pb) {
        pb.innerHTML = arrowSvg("prev", !prevDisabled);
        pb.classList.toggle("disabled", prevDisabled);
        if (prevDisabled) {
          pb.setAttribute("tabindex", "-1");
          pb.setAttribute("aria-disabled", "true");
          //pb.setAttribute("aria-hidden", "true");
        } else {
          pb.setAttribute("tabindex", "0");
          pb.removeAttribute("aria-disabled");
        }
      }
      if (nb) {
        nb.innerHTML = arrowSvg("next", !nextDisabled);
        nb.classList.toggle("disabled", nextDisabled);
        if (nextDisabled) {
          nb.setAttribute("tabindex", "-1");
          nb.setAttribute("aria-disabled", "true");
          //nb.setAttribute("aria-hidden", "true");
        } else {
          nb.setAttribute("tabindex", "0");
          nb.removeAttribute("aria-disabled");
        }
      }
    }

    /* ── Mobile 按钮 ── */
    function updateMobileNav() {
      if (mobilePrevBtn) {
        mobilePrevBtn.classList.toggle("disabled", currentIndex === 0);
      }
      if (mobileNextBtn) {
        mobileNextBtn.classList.toggle(
          "disabled",
          currentIndex >= fullQuestionList.length - 1,
        );
      }
    }

    /* ── Submit 按钮 ── */
    function updateSubmitBtn() {
      var show =
        quizCompleted ||
        (currentIndex === fullQuestionList.length - 1 &&
          !!answerMap[fullQuestionList[currentIndex].code]);
      if (isMobile) {
        if (pcSubmitBtn) {
          pcSubmitBtn.classList.remove("show");
        }
        if (mobileSubmitBtn) {
          mobileSubmitBtn.classList.toggle("show", show);
        }
      } else {
        if (mobileSubmitBtn) {
          mobileSubmitBtn.classList.remove("show");
        }
        if (pcSubmitBtn) {
          pcSubmitBtn.classList.toggle("show", show);
        }
      }
      if (quizSection) {
        quizSection.classList.toggle("pc-question", show && !isMobile);
      }
    }

    /* ── 进度条 ──
       步数映射（total = fullQuestionList.length = N+1）：
         显示Q0时到达 = 步数1，pct = 1/total
         Q0答完切Q1 = 步数2，pct = 2/total
         Q1答完切Q2 = 步数3，pct = 3/total
         ...
         最后一题答完 = 步数total，pct = 100%
    */
    function updateProgress() {
      if (progressLocked) {
        if (progressInner) {
          progressInner.style.width = "100%";
        }
        if (progressAvatar) {
          var eo = isMobile ? 60 : 100;
          progressAvatar.style.left = "calc(100% - " + eo + "px)";
        }
        return;
      }
      if (fullQuestionList.length <= 1) {
        if (progressInner) {
          progressInner.style.width = "0%";
        }
        if (progressAvatar) {
          progressAvatar.style.left = "0px";
        }
        return;
      }
      var total = fullQuestionList.length;
      var pct = (maxCompletedSteps / total) * 100;
      if (progressInner) {
        progressInner.style.width = pct + "%";
      }
      if (progressAvatar) {
        var avatarLeft;
        if (maxCompletedSteps <= 0) {
          avatarLeft = "0px";
        } else if (maxCompletedSteps >= total) {
          var eo2 = isMobile ? 60 : 100;
          avatarLeft = "calc(100% - " + eo2 + "px)";
        } else {
          var mo = isMobile ? 32.5 : 40;
          avatarLeft = "calc(" + pct + "% - " + mo + "px)";
        }
        progressAvatar.style.left = avatarLeft;
      }
    }

    /* ── 提交 ── */
    function submitQuiz() {
      var unanswered = fullQuestionList.some(function (q) {
        return !answerMap[q.code];
      });
      if (unanswered) return;
      var pcL = pcSubmitBtn && pcSubmitBtn.querySelector(".submit-loading");
      if (pcL) {
        pcL.classList.add("submit-loading-show");
      }
      if (mobileSubmitBtn) {
        mobileSubmitBtn.classList.add("loading");
      }
      var quizType = q0SelectedRole === "A" ? "MMTI" : "PMTI";
      var answerList = fullQuestionList.map(function (q) {
        return { questionCode: q.code, optionCode: answerMap[q.code] };
      });
      fetch(apiUrl + "/api/station/activity/quiz/submit", {
        method: "POST",
        headers: Object.assign(
          { "Content-Type": "application/json" },
          apiHeaders,
        ),
        body: JSON.stringify({
          activityCode: activityCode,
          quizType: quizType,
          answers: answerList,
        }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (+data.code === 200) {
            submitCode = data.result && data.result.submitCode;
            quizSection.classList.remove("show");
            emailSection.classList.add("show");
            if (emailInput) {
              emailInput.value = "";
            }
            if (emailCheckbox) {
              emailCheckbox.checked = false;
            }
            emailSection.scrollIntoView({ behavior: "smooth" });
          } else {
            alert && alert(data.message || "Submit failed");
          }
        })
        .catch(function (err) {
          alert && alert(err.message || "Request failed");
        })
        .finally(function () {
          if (pcL) {
            pcL.classList.remove("submit-loading-show");
          }
          if (mobileSubmitBtn) {
            mobileSubmitBtn.classList.remove("loading");
          }
        });
    }

    function fetchResult() {
      if (!submitCode) {
        showResult(null);
        return;
      }
      fetch(
        apiUrl + "/api/station/activity/quiz/result?submitCode=" + submitCode,
        { headers: apiHeaders },
      )
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          showResult(+data.code === 200 ? data.result : null);
        })
        .catch(function () {
          showResult(null);
        });
    }

    function showResult(resultData) {
      emailSection.classList.remove("show");
      resultSection.classList.add("show");
      resultSection.scrollIntoView({ behavior: "smooth" });
      var pool = q0SelectedRole === "A" ? quizA.results : quizB.results;
      var matched = null;
      /* 用 resultCardCode 匹配配置的 result block key */
      var cardCode = resultData && resultData.resultCardCode;
      if (cardCode && pool) {
        for (var i = 0; i < pool.length; i++) {
          if (pool[i].key === cardCode) {
            matched = pool[i];
            break;
          }
        }
      }
      /* 兜底取第一个 */
      if (!matched && pool && pool.length > 0) {
        matched = pool[0];
      }
      if (!matched) return;
      /* levelValue 有值则覆盖星级，否则用配置值（starLabel 中可含星级文本） */
      var cfg = Object.assign({}, matched);
      if (
        resultData &&
        resultData.levelValue !== undefined &&
        resultData.levelValue !== null &&
        resultData.levelValue !== ""
      ) {
        cfg.starLevel = parseInt(resultData.levelValue) || 0;
      }
      currentResultConfig = cfg;
      renderResultCard(cfg);
      /* 填充截图容器（result-dialog-overlay）供 Save Image 使用，但不弹出 */
      fillSaveImageContainer(cfg);
    }

    function renderResultCard(cfg) {
      var imgUrl =
        isMobile && cfg.mobileBgUrl ? cfg.mobileBgUrl : cfg.pcBgUrl || "";
      var bgColor = cfg.bgColor || "#fef5f0";
      var starCount = parseInt(cfg.starLevel) || 0;
      var actionsHtml = "";
      if (cfg.actions && cfg.actions.length) {
        var valid = cfg.actions.filter(function (a) {
          return a.title || a.desc;
        });
        if (valid.length) {
          actionsHtml = '<div class="result-action-section">';
          if (cfg.actionLabel) {
            actionsHtml +=
              '<div class="result-action-label">' + cfg.actionLabel + "</div>";
          }
          valid.forEach(function (a, ai) {
            if (isMobile) {
              actionsHtml += '<div class="result-action-item">';
              actionsHtml += '<div class="result-action-header">';
              actionsHtml +=
                '<span class="result-action-num">' +
                String(ai + 1).padStart(2, "0") +
                "</span>";
              if (a.title) {
                actionsHtml +=
                  '<span class="result-action-title">' + a.title + "</span>";
              }
              actionsHtml += "</div>";
              if (a.desc) {
                actionsHtml +=
                  '<div class="result-action-desc">' + a.desc + "</div>";
              }
              actionsHtml += "</div>";
            } else {
              actionsHtml +=
                '<div class="result-action-item"><div class="result-action-num">' +
                String(ai + 1).padStart(2, "0") +
                '</div><div class="result-action-body">';
              if (a.title) {
                actionsHtml +=
                  '<div class="result-action-title">' + a.title + "</div>";
              }
              if (a.desc) {
                actionsHtml +=
                  '<div class="result-action-desc">' + a.desc + "</div>";
              }
              actionsHtml += "</div></div>";
            }
          });
          actionsHtml += "</div>";
        }
      }
      var left = "";
      if (cfg.cardTitle) {
        left += '<div class="result-card-title">' + cfg.cardTitle + "</div>";
      }
      if (cfg.cardSubTitle) {
        left += '<div class="result-card-desc">' + cfg.cardSubTitle + "</div>";
      }
      if (starCount > 0 || cfg.starLabel) {
        left += '<div class="result-card-stars">';
        if (cfg.starLabel) {
          left +=
            '<span class="result-card-star-label">' +
            cfg.starLabel +
            ":</span>";
        }
        left +=
          '<span class="result-card-star-icons">' +
          buildStars(starCount) +
          "</span></div>";
      }
      if (cfg.userQuote) {
        left +=
          '<div class="result-card-quote">' + (cfg.userQuote || "") + "</div>";
      }
      left += actionsHtml;
      var html =
        '<div class="result-card-inner" style="background:' + bgColor + '">';
      if (isMobile && imgUrl) {
        html +=
          '<div class="result-card-right result-card-right--top"><img src="' +
          imgUrl +
          '" alt="' +
          (cfg.cardTitle || "").replace(/"/g, "&quot;") +
          '" class="result-card-img" loading="lazy"></div><div class="result-card-left">' +
          left +
          "</div>";
      } else {
        html += '<div class="result-card-left">' + left + "</div>";
        if (imgUrl) {
          html +=
            '<div class="result-card-right"><img src="' +
            imgUrl +
            '" alt="' +
            (cfg.cardTitle || "").replace(/"/g, "&quot;") +
            '" class="result-card-img" loading="lazy"></div>';
        }
      }
      html += "</div>";
      if (resultCardEl) {
        resultCardEl.innerHTML = html;
      }
      var resultDescEl = document.querySelector(".result-desc-html");
      if (resultDescEl) {
        // block resultDescHtml takes priority; fall back to global shareConfig.resultDescHtml
        resultDescEl.innerHTML =
          cfg.resultDescHtml ||
          (shareConfig && shareConfig.resultDescHtml) ||
          "";
      }
    }

    /* fillSaveImageContainer：填充截图容器内容，供 Save Image 的 html2canvas 截取
       容器（result-dialog-overlay）始终隐藏，不作为弹框弹出 */
    function fillSaveImageContainer(cfg) {
      if (!resultDialogOverlay) return;
      var imgUrl = cfg.pcBgUrl || "";
      var imgUrlMob = cfg.mobileBgUrl || imgUrl;
      var starCount = parseInt(cfg.starLevel) || 0;
      if (dialogHeadlineEl) {
        dialogHeadlineEl.innerHTML = cfg.dialogHeadline || "";
      }
      if (dialogTitleEl) {
        // fallback to cardTitle if dialog-specific field not configured
        dialogTitleEl.innerHTML = cfg.dialogContentTitle || cfg.cardTitle || "";
      }
      if (dialogDescEl) {
        // fallback to cardSubTitle if dialog-specific field not configured
        dialogDescEl.innerHTML =
          cfg.dialogContentDesc || cfg.cardSubTitle || "";
      }
      if (dialogStarsEl) {
        var starLabelText = cfg.dialogStarLabel || cfg.starLabel || "";
        var starsHtml = starLabelText
          ? '<span class="result-card-star-label">' + starLabelText + ":</span>"
          : "";
        starsHtml += buildStars(starCount);
        dialogStarsEl.innerHTML = starsHtml;
      }
      if (dialogQrcodeImg) {
        if (cfg.shareQrcodeUrl) {
          dialogQrcodeImg.src = cfg.shareQrcodeUrl;
          dialogQrcodeImg.parentElement.style.display = "block";
        } else {
          dialogQrcodeImg.parentElement.style.display = "none";
        }
      }
      if (dialogImg) {
        /* PC截图用PC图，Mobile截图用Mobile图 */
        dialogImg.src = isMobile ? imgUrlMob : imgUrl;
        dialogImg.alt = cfg.cardTitle || "";
        dialogImg.parentElement.style.display = (isMobile ? imgUrlMob : imgUrl)
          ? "flex"
          : "none";
      }
      /* 不调用 classList.add('show')，容器保持隐藏 */
    }

    if (dialogClose) {
      dialogClose.addEventListener("click", function () {
        resultDialogOverlay.classList.remove("show");
      });
    }
    /* 弹框内的 Share/Retake 按钮 */
    var dialogBtnShare = root.querySelector(".result-dialog .btn-share");
    var dialogBtnRetake = root.querySelector(".result-dialog .btn-retake");
    if (dialogBtnShare) {
      dialogBtnShare.addEventListener("click", function () {
        if (currentResultConfig) {
          fillShareModal(currentResultConfig);
        }
        shareOverlay.classList.add("show");
        document.body.style.overflow = "hidden";
      });
    }
    if (dialogBtnRetake) {
      dialogBtnRetake.addEventListener("click", resetAll);
    }
    if (resultDialogOverlay) {
      resultDialogOverlay.addEventListener("click", function (e) {
        if (e.target === resultDialogOverlay) {
          resultDialogOverlay.classList.remove("show");
        }
      });
    }
    if (btnShare) {
      btnShare.addEventListener("click", function () {
        if (currentResultConfig) {
          fillShareModal(currentResultConfig);
        }

        shareOverlay.classList.add("show");
        document.body.style.overflow = "hidden";
      });
    }
    if (btnRetake) {
      btnRetake.addEventListener("click", resetAll);
    }

    function fillShareModal(cfg) {
      if (shareCardTitle) {
        shareCardTitle.innerHTML =
          cfg.dialogContentTitle || cfg.cardTitle || "";
      }
      if (shareCardSubtitle) {
        shareCardSubtitle.innerHTML =
          cfg.dialogContentDesc || cfg.cardSubTitle || "";
      }
      /* 星级 */
      var shareStarsEl = root.querySelector(".share-card-stars");
      if (shareStarsEl) {
        var sc = parseInt(cfg.starLevel) || 0;
        var slbl = cfg.dialogStarLabel || cfg.starLabel || "";
        var sh = slbl
          ? '<span class="result-card-star-label" style="font-size:13px;font-weight:700;color:#35353b;margin-right:6px;">' +
            slbl +
            ":</span>"
          : "";
        sh += buildStars(sc);
        shareStarsEl.innerHTML = sh;
      }
      if (shareQrcodeImg) {
        if (cfg.shareQrcodeUrl) {
          shareQrcodeImg.src = cfg.shareQrcodeUrl;
          shareQrcodeImg.style.display = "block";
          shareQrcodeImg.parentElement.style.display = "block";
        } else {
          shareQrcodeImg.style.display = "none";
          shareQrcodeImg.parentElement.style.display = "none";
        }
      }
      if (shareCardImg) {
        var shareImgUrl = isMobile
          ? cfg.saveMobileImgUrl || cfg.savePcImgUrl || ""
          : cfg.savePcImgUrl || "";
        shareCardImg.src = shareImgUrl;
        shareCardImg.alt = cfg.cardTitle || "";
      }
    }

    function validateEmail() {
      var val = emailInput ? emailInput.value.trim() : "";
      if (!val) {
        if (errorTip) {
          errorTip.textContent = validationText;
          errorTip.classList.add("show");
        }
        return null;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
        if (errorTip) {
          errorTip.textContent = validationEmail;
          errorTip.classList.add("show");
        }
        return null;
      }
      if (errorTip) {
        errorTip.classList.remove("show");
      }
      return val;
    }

    if (emailInput) {
      emailInput.addEventListener("input", function () {
        var valid = validateEmail();
        if (emailSubmitBtn) {
          emailSubmitBtn.classList.toggle("active-submit", !!valid);
        }
      });
    }
    if (emailSubmitBtn) {
      emailSubmitBtn.addEventListener("click", function (e) {
        e.preventDefault();
        var email = validateEmail();
        if (!email) return;
        var loading = emailSubmitBtn.querySelector(".submit-loading");
        if (loading) {
          loading.classList.add("submit-loading-show");
        }
        var subscribeChecked = !!(emailCheckbox && emailCheckbox.checked);
        fetch(apiUrl + "/api/station/activity/quiz/email", {
          method: "POST",
          headers: Object.assign(
            { "Content-Type": "application/json" },
            apiHeaders,
          ),
          body: JSON.stringify({
            submitCode: submitCode || null,
            email: email,
            subscribeChecked: subscribeChecked,
          }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (res) {
            if (+res.code === 200) {
              if (luteTrack) {
                luteTrack("event:join-now:complete-registration");
              }
              fetchResult();
            } else {
              alert && alert(res.message || "Submit failed");
            }
          })
          .catch(function (err) {
            alert && alert((err && err.message) || "Request failed");
          })
          .finally(function () {
            if (loading) {
              loading.classList.remove("submit-loading-show");
            }
          });
      });
    }
    if (ignoreLink) {
      ignoreLink.addEventListener("click", function (e) {
        e.preventDefault();
        if (luteTrack) {
          luteTrack("event:join-now:complete-registration");
        }
        fetchResult();
      });
    }
    if (shareModalClose) {
      shareModalClose.addEventListener("click", function () {
        shareOverlay.classList.remove("show");
        document.body.style.overflow = "";
      });
    }
    if (shareOverlay) {
      shareOverlay.addEventListener("click", function (e) {
        if (e.target === shareOverlay) {
          shareOverlay.classList.remove("show");
          document.body.style.overflow = "";
        }
      });
    }

    if (btnSaveImage) {
      btnSaveImage.addEventListener("click", function () {
        if (!currentResultConfig) return;
        var cfg = currentResultConfig;
        var imgUrl = isMobile
          ? cfg.saveMobileImgUrl || cfg.savePcImgUrl || ""
          : cfg.savePcImgUrl || "";
        if (!imgUrl) return;
        var a = document.createElement("a");
        a.href = imgUrl;
        a.download = "my-quiz-result.png";
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    }

    if (btnCopyLink) {
      btnCopyLink.addEventListener("click", function () {
        var url = (function () {
          var urlObj = new URL(window.location.href);
          urlObj.searchParams.delete("from_share");
          urlObj.searchParams.delete("submitCode");
          urlObj.searchParams.delete("quizType");
          urlObj.searchParams.set("from_share", "1");
          if (submitCode) {
            urlObj.searchParams.set("submitCode", submitCode);
          }
          //获取Q0题目选择的答案
          if (q0SelectedRole) {
            urlObj.searchParams.set("quizType", q0SelectedRole);
          }
          return urlObj.toString();
        })();
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            showCopyFeedback(btnCopyLink);
          });
        } else {
          var ta = document.createElement("textarea");
          ta.value = url;
          ta.style.cssText = "position:fixed;opacity:0;left:-9999px";
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
          showCopyFeedback(btnCopyLink);
        }
      });
    }

    function getPlainTextFromHtml(html) {
      var div = document.createElement("div");
      div.innerHTML = html || "";
      return (div.textContent || "").replace(/\s+/g, " ").trim();
    }

    function buildFacebookQuote() {
      var cfg = currentResultConfig || {};
      var title = getPlainTextFromHtml(
        cfg.dialogContentTitle || cfg.cardTitle || "",
      );
      var desc = getPlainTextFromHtml(
        cfg.dialogContentDesc || cfg.cardSubTitle || "",
      );
      var extra = (shareXText || "").replace(/\s+/g, " ").trim();
      var quote = [title, desc, extra].filter(Boolean).join(" ").trim();
      if (quote.length > 400) {
        quote = quote.slice(0, 397) + "...";
      }
      return quote;
    }

    if (btnShareX) {
      btnShareX.addEventListener("click", function () {
        var url = (function () {
          var urlObj = new URL(window.location.href);
          urlObj.searchParams.delete("from_share");
          urlObj.searchParams.delete("submitCode");
          urlObj.searchParams.delete("quizType");
          urlObj.searchParams.set("from_share", "1");
          if (submitCode) {
            urlObj.searchParams.set("submitCode", submitCode);
          }
          //获取Q0题目选择的答案
          if (q0SelectedRole) {
            urlObj.searchParams.set("quizType", q0SelectedRole);
          }
          return urlObj.toString();
        })();
        var text = shareXText;
        window.open(
          "https://twitter.com/intent/tweet?url=" +
            encodeURIComponent(url) +
            "&text=" +
            encodeURIComponent(text),
          "_blank",
          "noopener",
        );
      });
    }
    function showCopyFeedback(btn) {
      var el = btn.querySelector(".share-action-text");
      if (!el) return;
      var orig = el.textContent;
      el.textContent = "Copied!";
      setTimeout(function () {
        el.textContent = orig;
      }, 2000);
    }

    function resetAll() {
      submitCode = null;
      currentResultConfig = null;
      q0SelectedRole = null;
      currentIndex = 0;
      answerMap = {};
      isMounted = false;
      quizCompleted = false;
      progressLocked = false;
      maxCompletedSteps = 0;
      if (progressInner) {
        progressInner.style.width = "0%";
      }
      if (progressAvatar) {
        progressAvatar.style.left = "0px";
      }
      if (resultCardEl) {
        resultCardEl.innerHTML = "";
      }
      var _rDesc = document.querySelector(".result-desc-html");
      if (_rDesc) {
        _rDesc.innerHTML = "";
      }
      if (resultDialogOverlay) {
        resultDialogOverlay.classList.remove("show");
      }
      if (shareOverlay) {
        shareOverlay.classList.remove("show");
      }
      resultSection.classList.remove("show");
      emailSection.classList.remove("show");
      quizSection.classList.remove("show");
      quizSection.classList.remove("pc-question");
      startQuiz();
      quizSection.scrollIntoView({ behavior: "smooth" });
    }

    // Check from_share=1 in URL: if present, use submitCode from URL to fetch and show result directly
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("from_share") === "1" && urlParams.get("submitCode")) {
      submitCode = urlParams.get("submitCode");
      q0SelectedRole = urlParams.get("quizType");
      fetchResult();
    } else {
      startQuiz();
    }
  });
})();
